import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
let ApiService = class ApiService {
    constructor(api) {
        this.api = api;
    }
    saveApi(item) {
        return this.api.apiSaveApi(item);
    }
    removeApi(item) {
        return this.api.removeApiApi(item);
    }
    uploadSwagger(file) {
        return this.api.uploadSwaggerApi(file);
    }
    getApiList(page, rows, name) {
        return this.api.getApiListApi({
            page,
            rows,
            name,
        });
    }
    setApiTag(item) {
        return this.api.setApiTagApi(item);
    }
    publish() {
        return this.api.publishApi();
    }
    createPdf(id) {
        return this.api.createPdf(id);
    }
    uploadPdf(data) {
        return this.api.uploadPdf(data);
    }
    updatePdfKey(params) {
        return this.api.updatePdfKey(params);
    }
    getPdfRecord(params) {
        return this.api.getPdfRecord(params);
    }
    deletePdfRecord(params) {
        return this.api.deletePdfRecord(params);
    }
    generatePdfBatch(data) {
        return this.api.generatePdfBatch(data);
    }
    downloadPdf(data) {
        return this.api.downloadPdf(data);
    }
    getAllApiList() {
        return this.api.getAllApiList();
    }
    documentGroupList(params) {
        return this.api.documentGroupList(params);
    }
    addVersionSubmit(data) {
        return this.api.addVersionSubmit(data);
    }
};
ApiService = __decorate([
    injectable(),
    __param(0, inject(Symbols.OpenApi)),
    __metadata("design:paramtypes", [Object])
], ApiService);
export { ApiService };
